import { useState } from "react";
import { useDeleteQuery } from "../hooks";
import Panel from "./Panel";
import Grid from "./Grid";
import Modal from "./Modal";
import DeleteButton from "./DeleteButton";
import EditButton from "./EditButton";
import TransactionAdd from "./TransactionAdd";
import TransactionEdit from "./TransactionEdit";
import ConfirmationModal from "./ConfirmationModal";
import Actions from "./Actions";
import AddButton from "./AddButton";
import { useGetQuery } from "../hooks";
import { PAGE_SIZE } from "../constants";

export default function TransactionCRUD({ user }) {
  const [page, setPage] = useState(1);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalId, setEditModalId] = useState(null);
  const [deleteModalId, setDeleteModalId] = useState(null);

  const transactionsQuery = useGetQuery("transactions", {
    queryParams: {
      page: page,
      user: user?.id,
      page_size: PAGE_SIZE,
    },
  });
  const deleteTransaction = useDeleteQuery("transactions");

  if (transactionsQuery.isLoading) {
    return null;
  }

  if (!user) {
    return (
      <Panel left="Submissions">
        <div className="p-4 text-center text-gray-500">
          No user data available
        </div>
      </Panel>
    );
  }

  return (
    <Panel left="Transactions">
      <Grid
        data={transactionsQuery.data.results}
        columnsTemplate="justify-between grid-cols-[auto_auto_auto]"
        renderTestId={(transaction) => `Transaction ${transaction.name}`}
        columns={[
          { header: "Name", key: "name" },
          { header: "Amount", key: "amount" },
          {
            header: "Actions",
            render: (transaction) => (
              <Actions>
                <EditButton
                  key="edit"
                  onClick={() => setEditModalId(transaction.id)}
                  disabled={!!transaction.submission}
                />
                <DeleteButton
                  key="delete"
                  onClick={() => setDeleteModalId(transaction.id)}
                  disabled={!!transaction.submission}
                />
              </Actions>
            ),
          },
        ]}
        pagination
        page={page}
        totalPages={Math.ceil(transactionsQuery.data.count / PAGE_SIZE)}
        onPageChange={setPage}
      />
      <AddButton className="mt-4" onClick={() => setAddModalOpen(true)} />
      <Modal
        isOpen={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        heading="Add Transaction"
      >
        <TransactionAdd
          user={user}
          callback={() => {
            setPage(1);
            setAddModalOpen(false);
          }}
        />
      </Modal>
      <Modal
        isOpen={editModalId !== null}
        onClose={() => setEditModalId(null)}
        heading="Edit Transaction"
      >
        {editModalId && (
          <TransactionEdit
            user={user}
            id={editModalId}
            callback={() => setEditModalId(null)}
          />
        )}
      </Modal>
      <ConfirmationModal
        isOpen={deleteModalId !== null}
        onClose={() => setDeleteModalId(null)}
        heading="Delete Transaction"
        message="Are you sure you want to delete this transaction?"
        confirmLabel="Delete"
        onConfirm={() => {
          deleteTransaction.mutate(deleteModalId);
          setDeleteModalId(null);
        }}
      />
    </Panel>
  );
}
